import { MAP_LAYER_FACTS } from '@/api/rest/resources/types/fact';
import { UnitEnum } from '@/api/rest/resources/types/units';
import { Slider } from '@/components/widgets/a/Slider/Slider';
import { DEFAULT_LAYER_OPACITY, useControlsContext } from '@/components/widgets/o/Map/hooks/useFormControls';

export const OpacitySlider = ({ layer }: { layer: MAP_LAYER_FACTS }) => {
  const controlsForm = useControlsContext();
  const opacityValue = controlsForm.watch('layerOpacity');
  const layerOpacityValue = opacityValue?.[`${layer}`] ?? DEFAULT_LAYER_OPACITY;

  const handleOnChange = (value: number) => {
    const layerOpacity = {
      ...opacityValue,
      [`${layer}`]: value,
    };
    controlsForm.setValue('layerOpacity', layerOpacity);
  };

  return (
    <Slider
      value={layerOpacityValue}
      onChange={(value) => handleOnChange(value)}
      showMinMax={true}
      unit={UnitEnum['%']}
    />
  );
};
